export const CUSTOMERLIST = "CUSTOMERLIST"
export const CUSTOMERSTATUS = "CUSTOMERSTATUS"
export const CUSTOMERDETAILS = "CUSTOMERDETAILS"




